import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { giftCardcheckingBalance } from 'actions/EntityActions';
import { Paper, TextField } from '@mui/material';
import { formInput } from 'actions/FormActions';
import { showSnackbar } from 'actions/CommonActions';
// Basic Components
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import Button from 'screens/components/basic/Button';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class POSGiftCheckBalance extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formattedCardNumber: "",
      balanceChecked: false,
      giftCardProcessError: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.POSGiftCardCheckFailMessageTime &&
      (this.props.POSGiftCardCheckFailMessageTime !== prevProps.POSGiftCardCheckFailMessageTime)) {
      this.displayGiftCardError();
      this.clearStateForm();
    }
  }

  displayGiftCardError = () => {
    this.setState({ giftCardProcessError: true }, () => {
      setTimeout(() => {
        this.setState({ giftCardProcessError: false });
      }, 3000);
    });
  }

  checkGiftCardBalance = () => {
    const { branchId, cardNumber } = this.props;
    if (!cardNumber) {
      this.props.showSnackbar(this.props.t('pos.giftcardPurchase.checkBalance.cardNumCannotBeEmpty'));
      return;
    }
    const model = {
      BranchId: branchId,
      cardNumber: cardNumber
    };
    this.props.giftCardcheckingBalance(model);
    this.setState({ balanceChecked: true });
  }

  handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    let formattedValue = "";
    for (let i = 0; i < value.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += " ";
      }
      formattedValue += value[i];
    }

    this.setState({ formattedCardNumber: formattedValue });
    this.props.formInput(value, "POSCardBalanceCheckCardNumber")
  }

  clearStateForm = () => {
    this.props.formInput("", "POSCardBalanceCheckCardNumber")
    this.setState({
      formattedCardNumber: "",
      balanceChecked: false
    });
  }

  render() {
    const { t } = this.props; 
    const p = this.props;
    const { balanceChecked } = this.state;
    const balance = balanceChecked && p.POSGiftCardCheckResult ? "$" + p.POSGiftCardCheckResult.balance : "$ ---";
    return (
      <DialogInput
        title={<DialogHeaderWithClose text={t('pos.giftcardPurchase.checkBalance.checkBalance')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
        actions={[
          <Button
            key={1}
            name="buttonRefundDialogCancel"
            type="Button"
            className="corner_X"
            primary={false}
            onTouchTap={() => { this.props.onCancel(), this.clearStateForm() }} />,
          <Button
            key={2}
            className="pull-right space"
            name="buttonRefundDialogConfirm"
            label={t('common.confirm')}
            primary={true}
            onTouchTap={() => this.checkGiftCardBalance()} />,
          <Button
            key={3}
            className="pull-right space"
            name="buttonRefundDialogClear"
            label={t('pos.giftcardPurchase.checkBalance.clear')}
            primary={true}
            onTouchTap={() => this.clearStateForm()} />]}

        modal={true}
        style={{ zIndex: '980' }}
        open={this.props.show}
        autoScrollBodyContent={true}>
        <div>
          <div>
            <h4>{t('pos.giftcardPurchase.checkBalance.fillUpInfo')}</h4>
            {this.state.giftCardProcessError ? (
              <h5 style={{ color: 'red', animation: 'slideInOut 5s', fontSize: '20px', fontWeight: 'bold' }}>
                {this.props.POSGiftCardCheckFailMessage}
              </h5>
            ) : null}
            <div className="row">
              <div className="col-lg-12">
                <Paper style={{
                  padding: '20px',
                  marginBottom: '20px',
                  marginTop: '20px',
                  borderRadius: '15px',
                  background: 'linear-gradient(45deg, #a697e2 30%, #8a73ea 90%)',
                  boxShadow: '0 3px 5px 2px rgba(198, 186, 246, .3)'
                }}>
                  <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                    <h2 style={{ width: '75%' }}>{t('common.giftCard')}</h2>
                    <h2 style={{ width: '20%', textAlign: 'left', color: "white" }}>{t('pos.giftcardPurchase.checkBalance.balance')}</h2>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                    <div style={{ width: '75%' }}>
                      <TextField
                        className="POSGiftCard-input"
                        name={`POSGiftCardPurchaseCardNumber`}
                        fullWidth={true}
                        type="text"
                        floatingLabelText={t('pos.giftcardPurchase.checkBalance.giftCardNumber')}
                        hintText={t('pos.giftcardPurchase.checkBalance.enterScanCardNumber')}
                        floatingLabelStyle={{ color: 'white', fontSize: '20px' }}
                        hintStyle={{ color: 'white', fontSize: '20px' }}
                        value={this.state.formattedCardNumber}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div style={{ width: '20%', textAlign: 'left' }}>
                      {<div style={{ fontSize: '1.5em' }}>{balance}</div>}
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </DialogInput>
    );
  }
}

function mapStateToProps(state) {
  return {
    branchId: state.common.branchId,
    cardNumber: state.form.POSCardBalanceCheckCardNumber || "",
    POSGiftCardCheckResultTime: state.entity.POSGiftCardCheckResultTime || null,
    POSGiftCardCheckResult: state.entity.POSGiftCardCheckResult || null,
    POSGiftCardCheckFailMessage: state.entity.POSGiftCardCheckFailMessage,
    POSGiftCardCheckFailMessageTime: state.entity.POSGiftCardCheckFailMessageTime
  };
}

function mapDispatchToProps(dispatch) {
  return {
    giftCardcheckingBalance: (model) => dispatch(giftCardcheckingBalance(model)),
    formInput: (value, name) => dispatch(formInput(value, name)),
    showSnackbar: (message) => dispatch(showSnackbar(message))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCheckBalance));
